
const digest = '20dca5c5bc4010249743049b222ad5033aa6fae1c0311b638a86a09a9fea1e1f';
const classes = {"wrapper":"_wrapper_nj0u9_1"};
const css = `._wrapper_nj0u9_1 {
  background: #fbfbfd;
}
._wrapper_nj0u9_1 tr th {
  color: #3e3f42;
  font-size: 12px;
  font-weight: 400;
  padding: 14px 8px;
}
._wrapper_nj0u9_1 tr th:first-of-type {
  padding-left: 14px;
}
._wrapper_nj0u9_1 tr th:last-of-type {
  padding-right: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  